import { Injectable } from "@angular/core";
import { Http, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs";

@Injectable()
export class NgMediaService {

    constructor(private http: Http) {
    }

    /**
     * For EDIT_CREATE mode
     * @param droppedFile
     */
    getBase64FromBlob(droppedFile: Blob): Observable<string> {
        return Observable.create(observer => {
            const reader: FileReader = new FileReader();
            let imageDataURL;
            reader.onload = (event) => {
                imageDataURL = reader.result as string;
            };
            reader.onloadend = (event) => {
                observer.next(imageDataURL);
                observer.complete();
            };
            reader.onerror = (event) => {
                const msg = "File is not readable";
                observer.throw(new Error(msg));
                observer.complete();
            };
            reader.readAsDataURL(droppedFile);
        });
    }
    /**
     * For EDIT_UPDATE mode
     * @param asset
     */
    getBase64FromUrl(url: string): Observable<string> {
        return this.http.get(url, {responseType: ResponseContentType.Blob})
            .map(res => res.blob())
            .flatMap(imgBlob => this.getBase64FromBlob(imgBlob));
    }
}
